import React, { useEffect, useState } from "react";
import { Box, Center, IconButton, Spinner, Tooltip } from "@chakra-ui/react";
import { Resize1, Resize2 } from "./icons";

const BrowserPdfViewer = ({ data, props }) => {
    const [blobUrl, setBlobUrl] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [showSpinner, setShowSpinner] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSpinner(false);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (data) {
            const base64Content = data.includes(",") ? data.split(",")[1] : data;
            const byteCharacters = atob(base64Content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            setBlobUrl(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [data]);

    useEffect(() => {
        const onMouseDown = (e) => {
            const isResizer =
                e.target.classList.contains("resizer") ||
                e.target.classList.contains("verresizer") ||
                e.target.closest?.('[class*="resizer"]') ||
                e.target.closest?.('[class*="Divider"]');

            if (isResizer) setIsDragging(true);
        };

        const onMouseUp = () => setIsDragging(false);

        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mouseup", onMouseUp);

        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, []);

    if (!blobUrl) return (
        <Box>
            <Center h="100vh" display="flex" flexDirection="column">
                {showSpinner && (<Spinner />)}
                {showSpinner && (<Box marginTop="10px">Loading PDF</Box>)}
                {!showSpinner && (<Box marginTop="10px" color={"red"}>Problem in Loading PDF</Box>)}

            </Center>
        </Box>
    );

    return (
        <Box w="100%" h="100vh" position="relative">
            <Box position={"absolute"} right={0} >
                {props.pdfFull ? (
                    <Tooltip label="Minimize PDF">
                        <IconButton
                            onClick={() => {
                                props.toggleEditor();
                            }}
                            size="lg"
                            bg="var(--secondary-main)"
                            aria-label="Resize pdf"
                            icon={<Resize2 />}
                            _hover={{ bg: "var(--primary-main)" }}
                        ></IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip label="Maximize PDF">
                        <IconButton
                            onClick={() => {
                                props.toggleEditor();
                                // setClientWidth(1);
                            }}
                            size="lg"
                            colorScheme="#f47c0d"
                            aria-label="Resize pdf"
                            icon={<Resize1 />}
                            bg="var(--secondary-main)"
                            _hover={{ bg: "var(--primary-main)" }}
                        ></IconButton>
                    </Tooltip>
                )}
            </Box>


            <iframe
                src={`${blobUrl}#view=FitH`}
                width="100%"
                height="100%"
                style={{ border: "none", display: "block" }}
            />
            {isDragging && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    zIndex={9999}
                    bg="transparent"
                    cursor="col-resize"
                />
            )}
        </Box>
    );
};

export default BrowserPdfViewer;